<prism-select 
  [selectOptions]="options"
  [label]="label"
  [placeHolder]="placeholder"
  [control]="control"
  [required]="required"
  [readOnly]="readOnly"
  [allowDeselect]="true"
  [labelClass]="labelClass"
  (onSelected)="emitYear($event)">
</prism-select>
